import { isMemberOf } from '~/utils/isMemberOf'

export const ORG_TABS = ['overview', 'installations', 'stations', 'contacts'] as const

export type OrgTab = (typeof ORG_TABS)[number]

export const orgTabLabel: Record<OrgTab, string> = {
  overview: 'Overview',
  installations: 'Installations',
  stations: 'Stations',
  contacts: 'Contacts'
}

export const INSTALLATION_VIEWS = ['status', 'hardware', 'timeline', 'retired'] as const

export type InstallationView = (typeof INSTALLATION_VIEWS)[number]

export const installationViewLabel: Record<InstallationView, string> = {
  status: 'Status',
  hardware: 'Hardware',
  timeline: 'Timeline',
  retired: 'Retired'
}

export const isOrgTab = isMemberOf(ORG_TABS)

export const isInstallationView = isMemberOf(INSTALLATION_VIEWS)
